import React, { useState } from 'react';

export default function LoginPage({ onLogin }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      const ok = onLogin(password);
      if (!ok) {
        setError('चुकीचा पासवर्ड | Wrong password');
        setLoading(false);
      }
    }, 800);
  };

  return (
    <div className="login-page">
      <div className="login-bg" />
      
      {/* Decorative circles */}
      <div style={{
        position: 'absolute', width: 400, height: 400, borderRadius: '50%',
        border: '1px solid rgba(255,107,53,0.1)',
        top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        pointerEvents: 'none'
      }} />
      <div style={{
        position: 'absolute', width: 600, height: 600, borderRadius: '50%',
        border: '1px solid rgba(255,107,53,0.05)',
        top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        pointerEvents: 'none'
      }} />

      <div className="login-card">
        <div className="login-logo">
          <div className="logo-icon">🛺</div>
          <h1>Smart Sangola</h1>
          <p>Tumcha Local Super App – Admin Panel</p>
          <p style={{ marginTop: 4, fontSize: 12, color: 'var(--text-muted)' }}>संगोळा, महाराष्ट्र</p>
        </div>

        <form onSubmit={handleLogin}>
          <div className="input-group">
            <label className="input-label">Admin ID</label>
            <input
              className="input"
              value="admin@sangola"
              readOnly
              style={{ opacity: 0.6 }}
            />
          </div>

          <div className="input-group">
            <label className="input-label">पासवर्ड | Password</label>
            <input
              className="input"
              type="password"
              placeholder="Enter admin password"
              value={password}
              onChange={e => { setPassword(e.target.value); setError(''); }}
              autoFocus
            />
          </div>

          {error && (
            <div style={{
              background: 'var(--danger-bg)', border: '1px solid var(--danger)',
              borderRadius: 8, padding: '10px 14px', fontSize: 13,
              color: 'var(--danger)', marginBottom: 16
            }}>
              ⚠️ {error}
            </div>
          )}

          <button
            type="submit"
            className="btn btn-primary w-full"
            style={{ justifyContent: 'center', padding: '12px', fontSize: 15, marginTop: 4 }}
            disabled={loading}
          >
            {loading ? (
              <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{
                  width: 16, height: 16, border: '2px solid rgba(255,255,255,0.3)',
                  borderTopColor: 'white', borderRadius: '50%',
                  animation: 'spin 0.7s linear infinite',
                  display: 'inline-block'
                }} />
                लॉगिन होत आहे...
              </span>
            ) : '🔐 Admin Login'}
          </button>
        </form>



        <div style={{
          marginTop: 24, padding: '14px', background: 'rgba(255,107,53,0.06)',
          border: '1px solid rgba(255,107,53,0.15)', borderRadius: 10,
          textAlign: 'center'
        }}>
          <div style={{ fontSize: 12, color: 'var(--text-secondary)', lineHeight: 1.7 }}>
            🌐 Web Admin Panel – PC/Laptop Only<br />
            📱 Mobile App for Customers, Shops & Delivery Boys
          </div>
        </div>
      </div>

      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}
